<template>

</template>

<script>
    import languageSwitch from 'components/button/languageSwitch.vue'

    export default {
        components: {
            languageSwitch
        },
        data() {
            return {};
        },
        mounted() {
            //remove hardcoded class 'hidden' which is there to prevent flickering on page load
            $(".submenu").each(function() {
                $(this).removeClass("hidden");
            });

            /**
             * IE 11 & Edge do not recognize :focus in CSS
             * The solution to make keyboard tab navigation possible inside the submenu
             * is to bind the javascript focus & blur events
             */
            const topLevelLinks = Array.from(document.querySelectorAll(".menu__link"));
            topLevelLinks.forEach(link => {
                if (link.nextElementSibling) {
                    link.addEventListener('focus', function () {
                        this.parentElement.classList.add('focus')
                    })

                    const subMenu = link.nextElementSibling
                    const subMenuLinks = subMenu.querySelectorAll('a')
                    const lastLinkIndex = subMenuLinks.length - 1
                    const lastLink = subMenuLinks[lastLinkIndex]

                    lastLink.addEventListener('blur', function () {
                        link.parentElement.classList.remove('focus')
                    })
                }
            })
        },
    };
</script>

<style rel="stylesheet/scss" lang="scss" type="text/css" scoped>
    nav {
        > ul {
            > li { //######## FIRST LEVEL ########
                > a {
                    padding-top:4px;
                    &:after {
                        content: '';
                        border-bottom: 2px solid #fff;
                        width: 97%;
                        display: block;
                        margin-left: 1px;
                        padding-bottom:2px;
                        opacity:0;
                    }

                    &.active, &:hover, &:focus {
                        padding-top:4px;
                        &:after {
                            opacity:1;
                            content: '';
                            border-bottom: 2px solid #fff;
                            width: 97%;
                            display: block;
                            margin-left: 1px;
                            padding-bottom:2px;
                            transition: opacity 0.2s linear;
                        }
                    }
                }
                > ul {
                    > li { // ########SECOND LEVEL ########
                        position: relative;

                        &:first-child {
                            padding-top: .5rem;
                            > ul > li:nth-child(2) { //apply this only if it's the first element on second level
                                padding-top: .5rem;
                            }
                        }
                        &:last-child {
                            padding-bottom: .75rem;
                        }
                        > a {
                            display: block;
                            padding-left: 1.25rem;
                            padding-right: 1.25rem;
                            padding-top: .5rem;
                            padding-bottom: .5rem;

                            &.active, &:hover, &:focus {
                                font-weight:800;
                                font-family: BeVietnamBold;
                            }
                        }
                    }
                }
            }
        }
    }

    .submenu {
        position: absolute;
        top: 100%;
        left: 28px;
        padding: 0;
        list-style: none;
        height: 1px;
        width: 1px;
        overflow: hidden;
        clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
        clip: rect(1px, 1px, 1px, 1px);
        opacity: 0;
        transition: opacity 0.1s ease-in-out;
    }

    .menu__item:hover .submenu,
    .menu__item.focus .submenu {
        opacity: 1;
        width: auto;
        height: auto;
        background: theme('colors.grey');
        clip: auto;
        transition: opacity 0.1s ease-in-out;

    }

</style>
